import { render, staticRenderFns } from "./EmployeeDataProvider.vue?vue&type=template&id=f0d7c4ec"
import script from "./EmployeeDataProvider.vue?vue&type=script&lang=ts"
export * from "./EmployeeDataProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d7c4ec')) {
      api.createRecord('f0d7c4ec', component.options)
    } else {
      api.reload('f0d7c4ec', component.options)
    }
    module.hot.accept("./EmployeeDataProvider.vue?vue&type=template&id=f0d7c4ec", function () {
      api.rerender('f0d7c4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeDataProvider.vue"
export default component.exports